import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { User } from '../models/user';
import { PartnerAccessService } from '../services/partner-portal/partner-access.service';

/** The Partner Portal shell needs the Portal grant. UX only: the API enforces it. */
export const partnerPortalGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const user = inject(User);
  const partnerAccessService = inject(PartnerAccessService);

  if (!user.access_token) {
    return router.createUrlTree(['/auth/login'], { queryParams: { redirectUrl: state.url } });
  }
  const access = await partnerAccessService.load();
  return access.portal ? true : router.createUrlTree(['customer/partner-no-access']);
};
